import React, { Component } from 'react'
import styled from 'styled-components'
import VideoCover from 'react-video-cover'
import { Container, media } from 'styled-bootstrap-grid'
import { keyframes } from 'styled-components';

import { Text } from 'ui/styles/utils'

export default class Hero extends Component {
  state = { ready: false }

  setReady = () => {
    const { ready } = this.state
    if (!ready) {
      this.setState({ ready: true })
    }
  }

  componentDidMount() {
    this.timeout = setTimeout(this.setReady, 3000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    const {
      text,
      image,
      video,
      showOverlay,
      overlayOpacity
    } = this.props

    const { ready } = this.state

    const videoOptions = video && {
      src: video.sourceUrl,
      preload: 'auto',
      autoPlay: 'autoPlay',
      playsInline: 'playsInline',
      muted: 'muted',
      loop: 'loop',
      onCanPlay: this.setReady
    }

    return (
      <Wrapper
        image={!video && image && image.sourceUrl}
        visible={ready}
      >
        {!video && image && !ready &&
          <ImageLoader
            onLoad={this.setReady}
            src={image.sourceUrl}
          />
        }
        <Container
          fluid
          style={{zIndex: 1}}
        >
          {ready &&
            <Header>{text}</Header>
          }
        </Container>
        {video &&
          <Video videoOptions={videoOptions} />
        }
        {showOverlay &&
          <Overlay opacity={overlayOpacity} />
        }
      </Wrapper>
   )
  }
}

const entry = keyframes`
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`

const Wrapper = styled.section`
  width: 100vw;
  height: 100vh;
  background: ${props => props.image ? `url(${props.image}) center / cover no-repeat` : 'none'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  opacity: ${props => props.visible ? 1 : 0};
  transition: all 500ms;
`

const ImageLoader = styled.img`
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  pointer-events: none;
`

const Header = styled(Text).attrs({ size: 'xxl', as: 'h1' })`
  font-family: ${props => props.theme.altDisplayFont};
  font-weight: normal;
  color: white;
  margin: auto;
  text-align: center;
  z-index: 1;
  max-width: 85%;

  animation: ${entry} 500ms 500ms both;

  ${media.lg`
    max-width: 75%;
  `}
`

const Video = styled(VideoCover)`
  display: block;
  position: absolute !important;
  top: 0;
  left: 0;
  z-index: 0;
`

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, ${props => props.opacity / 100});
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/Hero/index.js